import { forwardRef } from '@heroui/system';
import { PiMoonFill, PiSunDimFill } from 'react-icons/pi';
import { Switch, SwitchProps, extendVariants } from '@heroui/react';

export interface CustomSwitchProps extends Omit<SwitchProps, 'ref'> {
  showStartContent?: boolean;
  showEndContent?: boolean;
  childrenIsLeft?: boolean;
}

type CustomSwitchExtendedType = ReturnType<typeof extendVariants>;

export const CustomSwitchExtended: CustomSwitchExtendedType = extendVariants(Switch, {
  variants: {
    color: {
      default: {
        base: 'gap-3',
        wrapper: 'bg-base-50 mx-0 gap-3 row-reverse group-data-[selected=true]:bg-base-10',
        startContent: 'text-base-90',
        endContent: 'text-base-10',
        label: 'text-base-5',
        thumb: 'bg-base-90',
      },
    },
    size: {
      lg: {
        startContent: 'w-4 h-4 left-2',
        endContent: 'w-4 h-4 right-2',
        label: 'text-l-m!',
      },
      md: {
        startContent: 'w-3.5 h-3.5 left-1.5',
        endContent: 'w-3.5 h-3.5 right-1.5',
        label: 'text-m-m!',
      },
      sm: {
        startContent: 'w-3 h-3 left-1',
        endContent: 'w-3 h-3 right-1',
        label: 'text-m-m!',
      },
    },
    isDisabled: {
      true: {
        base: 'opacity-50',
      },
    },
  },
});

const CustomSwitch = forwardRef<'input', CustomSwitchProps>((props, ref) => {
  const {
    startContent,
    endContent,
    showStartContent,
    showEndContent,
    childrenIsLeft,
    isSelected,
    children,
    ...restProps
  } = props;

  return (
    <CustomSwitchExtended
      ref={ref}
      startContent={showStartContent ? <PiMoonFill /> : undefined}
      endContent={showEndContent ? <PiSunDimFill /> : undefined}
      isSelected={isSelected}
      classNames={{
        base: !!childrenIsLeft && 'flex-row-reverse',
      }}
      color="default"
      {...restProps}
    >
      {children}
    </CustomSwitchExtended>
  );
});

CustomSwitch.displayName = 'CustomSwitch';

export default CustomSwitch;
